// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/**
 * 获取员工档案列表
 */
export async function getProfileList(
  params: OA.EmployeeProfileListParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.EmployeeProfileListData>>('/api/v1/profiles/', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/**
 * 获取单个员工档案详情
 */
export async function getProfile(profileId: number, options?: { [key: string]: any }) {
  return request<OA.ApiResponse<OA.EmployeeProfile>>(`/api/v1/profiles/${profileId}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 根据用户ID获取员工档案
 */
export async function getProfileByUserId(userId: number, options?: { [key: string]: any }) {
  return request<OA.ApiResponse<OA.EmployeeProfile>>(`/api/v1/profiles/user/${userId}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 创建员工档案
 */
export async function createProfile(
  params: OA.CreateEmployeeProfileParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.EmployeeProfile>>('/api/v1/profiles/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/**
 * 更新员工档案
 */
export async function updateProfile(
  profileId: number,
  params: OA.UpdateEmployeeProfileParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.EmployeeProfile>>(`/api/v1/profiles/${profileId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
    ...(options || {}),
  });
}

/**
 * 删除员工档案
 */
export async function deleteProfile(profileId: number, options?: { [key: string]: any }) {
  return request<OA.ApiResponse<null>>(`/api/v1/profiles/${profileId}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

